import Vue from 'vue';

const resource = '/orderreceptionorderitems';

export default {
  // CUSTOM ENDPOINT
  getByOrderReception(idPublic) {
    return Vue.prototype.$axiosMainClient.get(
      `orderreceptions/${idPublic}${resource}`
    );
  },
};
